import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import styled from 'styled-components';
import { down } from 'styled-breakpoints';

const handleOnChange = onChange => ({ label, value }) => onChange(value, label);

const Select = ({
  className,
  onChange,
  options,
  placeholder,
  value,
  ...otherProps
}) => {
  value = options.find(option => option.value === value);

  return (
    <Container>
      <ReactSelect
        className={`selectContainer ${className}`}
        classNamePrefix="selectContainer"
        isSearchable
        name="searchable"
        noOptionsMessage={() => {}}
        onChange={handleOnChange(onChange)}
        options={options}
        placeholder={placeholder}
        value={value}
        {...otherProps}
      />
    </Container>
  );
};

Select.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

Select.defaultProps = {
  onChange: () => {},
  options: [],
  placeholder: 'Select...',
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  .selectContainer {
    font-family: ${props => props.theme.baseFontFamily};
    outline: none;
    ${down('sm')} {
      font-size: 70%;
    }
  }
  .selectContainer__placeholder {
    font-weight: 300;
    font-size: ${props => props.theme.formFontSize};
    line-height: calc(1em + 44px);
    padding-left: 1em;
    color: ${props => props.theme.placeholder};
  }

  .selectContainer__value-container > input {
    color: ${props => props.theme.subText};
    font-size: ${props => props.theme.formFontSize};
    font-weight: 300;
    padding: 0;
  }

  .Select-clear {
    display: none;
  }
  .Select-clear-zone {
    display: none;
  }
  .selectContainer__control {
    background-color: ${props => props.theme.lightestGray};
    border: 1px solid ${props => props.theme.border} !important;
    border-radius: 3px;
    box-shadow: inset ${props => props.theme.shadow} !important;
    cursor: pointer;
    color: ${props => props.theme.subText};
    padding: 0.5em 0em;
  }

  .SelectContainer__select__menu {
    color: ${props => props.theme.subText};
    font-size: ${props => props.theme.formFontSize};
    font-weight: 300;
    padding: 0;
  }
`;

export default Select;
